module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-600italic.e8426bc3.woff";